import { render, staticRenderFns } from "./WeChatVideoBot.vue?vue&type=template&id=4ae5bbf0&scoped=true&"
import script from "./WeChatVideoBot.vue?vue&type=script&lang=js&"
export * from "./WeChatVideoBot.vue?vue&type=script&lang=js&"
import style0 from "./WeChatVideoBot.vue?vue&type=style&index=0&id=4ae5bbf0&prod&lang=less&scoped=true&"
import style1 from "./WeChatVideoBot.vue?vue&type=style&index=1&id=4ae5bbf0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae5bbf0",
  null
  
)

export default component.exports